import { type Variants } from "framer-motion";

// Shared motion language — calm, precise, physical. Reused across surfaces so everything moves
// as one system. Framer Motion honours prefers-reduced-motion automatically via MotionConfig.

export const easeOut: [number, number, number, number] = [0.22, 1, 0.36, 1];

export const fadeRise: Variants = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.28, ease: easeOut } },
  exit: { opacity: 0, y: 6, transition: { duration: 0.16, ease: easeOut } },
};

export const messageIn: Variants = {
  hidden: { opacity: 0, y: 8, scale: 0.99 },
  visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.26, ease: easeOut } },
};

export const scrimFade: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.16 } },
  exit: { opacity: 0, transition: { duration: 0.14 } },
};

export const drawerSlide: Variants = {
  hidden: { x: 28, opacity: 0 },
  visible: { x: 0, opacity: 1, transition: { duration: 0.3, ease: easeOut } },
  exit: { x: 28, opacity: 0, transition: { duration: 0.18, ease: easeOut } },
};

export const paletteIn: Variants = {
  hidden: { opacity: 0, y: -8, scale: 0.98 },
  visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.2, ease: easeOut } },
  exit: { opacity: 0, y: -8, scale: 0.98, transition: { duration: 0.14 } },
};
